/**
 * Copyright © 2025-2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Copy } from "lucide-react";
import { FC, type JSX } from "react";

import ToastIcon from "../../../../components/ToastIcon";
import useAppInfo from "../../../../hooks/useAppInfo";
import TestIds from "../../../../testIds";
import useToast from "../../../../util/useToast";

const AppVersion: FC = (): JSX.Element | undefined => {
  const { notify } = useToast();
  const { appInfoString } = useAppInfo();

  const onAppInfoClick = (): void => {
    navigator?.clipboard
      .writeText(appInfoString)
      .then((): void => {
        notify("Details copied to clipboard", {
          type: "success",
          icon: <ToastIcon>inventory</ToastIcon>,
        });
      })
      .catch((): void => {
        notify("Copy to clipboard unsuccessful", {
          type: "error",
          icon: <ToastIcon>Error</ToastIcon>,
        });
      });
  };

  if (!appInfoString) {
    return undefined;
  }

  return (
    <p className="text-2xs leading-3xs font-medium text-neutral-500">
      <button
        type="button"
        onClick={onAppInfoClick}
        data-testid={TestIds.feat.account.userAccount.appVersion.component}
        className="flex gap-1"
      >
        {appInfoString}
        <Copy aria-hidden size={16} />
      </button>
    </p>
  );
};

export default AppVersion;
